const log = {
    invalid_type: 'ประเภทบันทึกไม่ถูกต้อง',
};
export default Object.freeze(log);
